<template>
  <transition name="fadeout">
    <div v-if="isShowGuide" class="turn-guide" @click="hideGuide">
      <div class="turn-guide__bg"></div>
    </div>
  </transition>
  <div :class="['turn-head', partnerName]" :style="titleStyle">
    <div class="turn-head__qrcode">
      <a href="#" @click="openDownload($event)">
        <img :src="getParnterImg('qrcode')" />
        <span v-if="isMobile && !isIpad">下載APP＞</span>
      </a>
    </div>
    <div :class="['turn-head__logo', {'bsite': siteData}]">
      <img :src="getParnterImg('logo')" />
    </div>
    <div class="turn-head__click">
      <a href="#" class="turn-head__return" @click="turn($event, 'up')">
        <img src="/images/turnturn_click.svg" :class="[{ 'rotate-in-center': isAiApiFetch }]" />
        <span>再轉</span>
      </a>
      <transition name="fadeout">
        <div v-if="isShowGuide" class="turn-guide__png" @click="hideGuide">
          <img src="/images/landing_guide.png" />
        </div>
      </transition>
      <div v-if="!isMobile && isCartNum && !isDesktopIframe" class="friday_cart">
        <a href="https://shopping.friday.tw/ec2/shoppingcart">
          <i class="cart"></i>
          <span>{{ isCartNum }}</span>
        </a>
      </div>
    </div>
  </div>

  <div v-if="isShowDownload" class="turn-download">
    <div></div>
    <div>
      <div>
        <div class="turn-download__head">
          <i class="close" @click="openDownload($event)"></i>
          <template v-if="!isIpad">
            <a :href="appDownloadLink" target="_blank">去下載APP></a>
          </template>
        </div>
        <div class="turn-download__body">
          <!-- <p>或直接掃描QR Code進入網頁</p> -->
          <img :src="getParnterImg('qrcode')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app-header",
  data() {
    return {
      partnerCode: "00",
      partnerName: "friday",
      isMobile: /mobi(li)?/i.test(navigator.userAgent),
      isShowDownload: false,
      isShowGuide: false,
      isIosDevice: false,
      isIpad: false,
      isCartNum: null,
      isDesktopIframe: false,
      webInfo: {},
    };
  },
  props: {
    isAiApiFetch: {
      type: Boolean,
      default: () => false,
    },
    mobileCircleFetId: {
      type: String,
      default: () => null,
    },
    siteData: {
      type: Object,
      default: () => null,
    },
  },
  emits: ["turn", "setWebInfo"],
  created() {
    const { partnerCode, partnerName } = window["vue_router"].params;
    if (partnerName) {
      this.partnerName = partnerName;
    }
    if (partnerCode) {
      this.partnerCode = partnerCode;
    }

    // 取得網站設定
    this.getWebInfo();

    // 是否為Ipad
    if (/ipad/i.test(navigator.userAgent)) {
      this.isIpad = true;
    }

    // 是否為IOS設備
    if (/iphone/i.test(navigator.userAgent)) {
      this.isIosDevice = true;
    }

    // 是否來自大網崁IFRAME
    if (/d=1/i.test(location.search)) {
      this.isDesktopIframe = true;
    }

    // 第一次進入蓋板教學圖
    const turnGuideShown = localStorage.getItem("turnGuideShown");
    if (!turnGuideShown) {
      this.isShowGuide = true;
      localStorage.setItem("turnGuideShown", "view");

      // 蓋板教學圖5秒後移除
      setTimeout(() => {
        this.isShowGuide = false;
      }, 5000);
    }

    // 判斷購物車數量
    let bInfo = this.$cookies.get("FEEC-B2C-INFO");
    if (bInfo && bInfo.data && bInfo.data.shoppingBagCount) {
      this.isCartNum = bInfo.data.shoppingBagCount;
    }
  },
  methods: {
    getWebInfo() {
      // https://m.shopping.friday.tw/mobileapi/event/cycle/turnWebInfo/metrotaipei00
      fetch(
        `${this.configs.mApiPath}event/cycle/turnWebInfo/${this.partnerName}${this.partnerCode}`,
        {
          method: "GET",
        }
      )
        .then((res) => res.json())
        .then((json) => {
          if (json.code === "0000") {
            this.webInfo = json.data;
            this.setWebInfoMeta(json.data);
            this.$emit("setWebInfo", json.data);
          } else if (json.code === "C004") {
            window.location.replace("//" + location.host);
          }
        });
    },
    setWebInfoMeta(data) {
      document.querySelector("title").innerHTML = data.turnName;
      document.querySelector('meta[name="description"]').innerHTML =
        data.directions;
      document.querySelector('meta[name="keywords"]').innerHTML = data.keyword;
    },
    hideGuide() {
      this.isShowGuide = false;
      localStorage.setItem("turnGuideShown", "view");
    },
    openDownload(evt) {
      evt.preventDefault();
      this.isShowDownload = !this.isShowDownload;
    },
    turn(evt, pos) {
      evt.preventDefault();
      this.$emit("turn");
      if (pos === "bottom") {
        window.scrollTo({
          top: 0,
        });
      }
    },
    getParnterImg(fileName) {
      if (this.siteData && this.siteData.siteId && fileName === "logo") {
        fileName = "dtype";
      }
      return `/images/${this.partnerName}/${fileName}.svg`;
    },
  },
  computed: {
    appDownloadLink() {
      let turnPath = this.configs.domain;
      if (this.partnerName !== "friday") {
        turnPath += "partner/" + this.partnerName;
      }
      if (this.partnerCode) {
        turnPath += this.partnerCode;
      }
      if (this.mobileCircleFetId) {
        turnPath += "?fetId=" + this.mobileCircleFetId;
      }
      return this.configs.appDynamiclink(turnPath);
    },
    titleStyle() {
      const style = {};
      if (this.siteData && this.siteData.siteId) {
        style["background-color"] = "#ffa200";
      } else {
        if (this.webInfo["turnBranch"]) {
          if (this.webInfo.mainColor1) {
            if (!this.webInfo.mainColor2) {
              style["background-color"] = this.webInfo.mainColor1;
            } else {
              style[
                "background"
              ] = `linear-gradient(90deg, ${this.webInfo.mainColor1}, ${this.webInfo.mainColor2})`;
            }
          } else {
            style["background-color"] = "#ff0063";
          }
        }
      }
      return style;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../style/_color.scss";

.friday_cart {
  position: absolute;
  top: 5px;
  right: -20px;
  a {
    position: relative;
    span {
      position: absolute;
      color: $red !important;
      font-size: 12px !important;
      width: 18px;
      height: 18px;
      background-color: #fff;
      border-radius: 100%;
      padding: 0.5px 1.5px;
      box-sizing: border-box;
      text-align: center;
      line-height: 17px;
      vertical-align: middle;
      position: absolute;
      top: -12px;
      right: -8px;
    }
  }
}

.turn-head {
  display: flex;
  justify-content: center;
  padding: 10px 10px;

  &__qrcode {
    display: flex;
    align-items: center;
    flex-basis: 25%;

    a {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      color: $white;

      img {
        flex: 1 1 35px;
        max-height: 95px;
        width: 100%;
      }

      span {
        flex: 1 1 100%;
        display: block;
        font-size: 1rem;
      }
    }
  }

  &__logo {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-basis: 30%;

    img {
      width: 90%;
      height: 70%;
    }
  }

  &__click {
    position: relative;
    display: flex;
    align-items: center;
    flex-basis: 25%;

    a {
      width: 100%;
      text-align: center;
      text-decoration: none;

      span {
        display: inline-block;
        text-align: center;
        font-size: 1rem;
        color: $white;
        width: 100%;
      }

      img {
        max-height: 60px;
      }
    }

    .friday_cart {
      span {
        display: block;
        width: 18px;
      }
    }
  }
}

.turn-guide {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 997;

  &__bg {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: $black;
    opacity: 0.6;
    z-index: 998;
  }

  &__png {
    position: absolute;
    right: 5px;
    top: 5px;
    z-index: 999;

    img {
      width: 180px;
    }
  }
}

.turn-download {
  z-index: 1;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;

  > div {
    &:first-child {
      width: 100%;
      height: 100%;
      background-color: $black;
      opacity: 0.6;
    }

    &:last-child {
      display: flex;
      z-index: 2;
      position: fixed;
      top: 0;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;

      > div {
        &:first-child {
          width: 90%;
          // height: 360px;
          background-color: $white;
          border-radius: 20px;
          max-width: 540px;
        }
      }
    }
  }

  &__head {
    position: relative;
    padding: 20px 0;
    text-align: center;

    a {
      font-size: 2.8rem;
      color: $blue-ribbon;
    }

    p {
      font-size: 2rem;
    }
  }

  &__body {
    color: $blue;
    text-align: center;
    padding-bottom: 20px;

    img {
      width: 35%;
      max-width: 200px;
      max-height: 200px;
    }
  }
}

@media screen and (max-width: 374px) {
  .turn-head {
    padding: 10px !important;
    align-items: center;
    &__qrcode {
      img {
        width: 70px !important;
      }
    }
    &__logo {
      img {
        width: 180px !important;
      }

      &.bsite {
        flex-basis: 50%;
        img {
          width: 150px !important;
        }
      }
    }
    &__click {
      display: block;
      img {
        width: 55px;
      }
      a {
        display: inline-flex;
        flex-direction: column;
        align-items: center;
      }
      span {
        width: fit-content !important;
      }
    }
  }
}

@media only screen and (min-device-width: 375px) and (max-device-width: 812px) {
  .turn-head {
    padding: 10px;
    &__qrcode {
      flex-basis: 20%;
      a {
        width: 100%;
      }
    }
    &__logo {
      flex-basis: 60%;
    }
    &__click {
      flex-basis: 20%;
      a {
        img {
          max-height: 55px;
        }
      }
    }
  }
}

@media screen and (min-width: 765px) {
  .turn-guide__png {
    right: 35%;

    img {
      width: 230px;
    }
  }
}

@media screen and (min-width: 1000px) {
  .turn-head__logo {
    img {
      width: 80% !important;
    }
  }
}

@media screen and (min-width: 1130px) {
  .turn-guide__png {
    right: 40%;

    img {
      width: 230px;
    }
  }

  .turn-guide {
    img {
      right: 100px;
      width: 250px;
    }
  }
}

.fadeout-leave-active {
  animation: fadeOut forwards 1s;
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
    display: none;
  }
}
</style>
